import { Http } from './http';
import { IStateScore, State } from '@types';

class StateHttp extends Http {
  prefix = 'state';

  async getAll () {
    const res = await this.get<State[]>('');

    return res.data;
  }

  async updateOne (id: number, params: UpdateStateParams) {
    const res = await this.put<State>(`/${id}`, params);

    return res.data;
  }

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('/update-bulk', params);

    return data;
  }
}

export const stateHttp = new StateHttp();

interface UpdateStateParams extends Omit<State, 'id'> {
  score: IStateScore,
}

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string[] | number | null;
}
